import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ToastrService } from 'ngx-toastr';
import { EndpointService } from '@app/core';
import { Observable } from 'rxjs/Observable';
import { EstructuraEspecifica, FiltroTableMasterGeneral, ValoresEspecificos } from '@app/shared';

@Injectable()
export class ModalSelectDataService {
  constructor(
    private http: HttpClient,
    private toastr: ToastrService,
    private api: EndpointService
  ) { }
  /**
 * Realiza la consulta de las columnas specificas de una maestra
 *
 * @param {EstructuraEspecifica} structure
 * @param {FiltroTableMasterGeneral[]} [filterMaster]
 * @param {string} [idRecords]
 * @param {*} [filterSede]
 * @returns {Promise<ValoresEspecificos[]>}
 * @memberof ModalSelectDataService
 */
  getColumnsSpecificMasterTable(
    structure: EstructuraEspecifica,
    filterMaster?: FiltroTableMasterGeneral[],
    idRecords?: string,
    filterSede?: any,
    offset?: any,
    limit?: any,
    filters?: any[]

  ): Promise<ValoresEspecificos[]> {
    const formData = {
      estructura: structure
    };

    if (filterMaster && filterMaster.length) {
      formData['condicion'] = filterMaster;
    }

    if (idRecords && idRecords.length) {
      formData['id_registro'] = idRecords;
    } else {
      if (offset != undefined && offset != null) {
        formData['offset'] = offset;
      }
      if (limit) {
        formData['limit'] = limit;
      }
      if (filters && filters.length) {
        formData['filtros'] = filters;
      }
    }

    if (filterSede) {
      formData['tarea_id'] = filterSede['tarea'];
      formData['columna'] = filterSede['columna'];
    }

    return new Promise((resolve, reject) => {
      this.http.post<ValoresEspecificos[]>(this.api.get('masterTableSpecificInformation'), formData).subscribe(
        specificValues => {
          resolve(specificValues);
        },
        err => {
          reject(err);
        }
      );
    });
  }

  /**
   *Obtiene la data para la tabla cuando el selector es de tipo Trámites
   *
   * @param {number[]} tramites
   * @param {string[]} estructura
   * @return {*}  {Promise<any[]>}
   * @memberof RefactorDynamicFormDataService
   */
  getSelectorUtils(tramites: number[], estructura: string[], filtro_tramite: string[], dinamico: boolean = false, selector_dinamico: any = null,
    id_tramite: any = null, filters: any[], offset?: any,
    limit?: any): Promise<any[]> {
    return new Promise((resolve, reject) => {
      let dataForm: any = {
        tramites: tramites,
        estructura: estructura,
      };
      if (dinamico) {
        dataForm["dinamico"] = dinamico;
        dataForm["consulta_dinamica"] = selector_dinamico;
      } else {
        dataForm["filtro_tramite"] = filtro_tramite;
        dataForm["id_tramite"] = id_tramite;
      }
      if (offset != undefined && offset != null) {
        dataForm['offset'] = offset;
      }
      if (limit) {
        dataForm['limit'] = limit;
      }
      if (filters) {
        dataForm['filtros_columnas'] = filters;
      }


      this.http.post<any[]>(this.api.get('selectorUtils'), dataForm).subscribe(
        resp => {
          resolve(resp);
        },
        err => {
          reject(err);
        }
      );
    });
  }

}


// WEBPACK FOOTER //
// ./src/app/shared/modal-select/shared/modal-select.data.service.ts